// extracted by mini-css-extract-plugin
module.exports = {"notifications":"Notifications_notifications__2yJoU"};